import { useEffect, useRef } from "react";
import { createQuillEditor, destroyQuillEditor, getQuillHtml } from "@utils/quill/editor";

export default function ModalQuillEditor({ value, onChange, className = "" }) {
  const wrapperRef = useRef(null);
  const initialValueRef = useRef(value);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return undefined;
    wrapper.innerHTML = "";
    const container = document.createElement("div");
    wrapper.appendChild(container);
    const quill = createQuillEditor({
      container,
      initialHtml: initialValueRef.current,
    });
    if (!quill) return undefined;

    const handleTextChange = () => onChangeRef.current(getQuillHtml(quill));
    quill.on("text-change", handleTextChange);
    return () => {
      destroyQuillEditor({ container, quill, textChangeHandler: handleTextChange });
      wrapper.innerHTML = "";
    };
  }, []);

  return <div ref={wrapperRef} className={`tour-add-quill ${className}`} />;
}
